<template>
  <div>
    <Table :columns="columns" :data="data">
      <template slot="activitytype" slot-scope="{row}">
        <span v-if="row.activity.activitytype =='recharger'">充值</span>
        <span v-else-if="row.activity.activitytype =='coupon'">优惠券</span>
      </template>
      <template slot="title" slot-scope="{row}">{{row.activity.title}}</template>
      <template slot="date" slot-scope="{row}">{{row.activity.begindate}}-{{row.activity.enddate}}</template>
      <template slot="status" slot-scope="{row}">
        <span v-if="row.activity.status ==0">有效</span>
        <span v-else-if="row.activity.status ==-1">无效</span>
      </template>
      <template slot="action" slot-scope="{row,index}">
        <Poptip transfer confirm title="要删除此商品活动?" @on-ok="fn_remove(row,index)">
          <button type="button" class="btn btn-danger">删除</button>
        </Poptip>
      </template>
    </Table>
    <Form class="m-t-20" :labelWidth="120">
      <Row :gutter="20">
        <Col span="10">
          <FormItem label="活动标题">
            <Select v-model="formData.activityid">
              <Option
                :value="item.id"
                :label="item.title"
                v-for="(item,index) in activityList"
                :key="index"
              ></Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <button type="button" class="btn btn-theme" @click="storeData">
            <i class="fa fa-plus"></i> 添加活动
          </button>
        </Col>
      </Row>
    </Form>
  </div>
</template>
<script>
import { storeGoodsActivityData, removeGoodsActivityData } from "@/api/goods";
export default {
  data() {
    return {
      columns: [
        {
          title: "#ID",
          key: "id",
          width: 70
        },
        {
          title: "活动类型",
          slot: "activitytype",
          width: 120
        },
        {
          title: "标题",
          slot: "title",
          width: 200
        },
        {
          title: "时间",
          slot: "date",
          width: 300
        },
        {
          title: "状态",
          slot: "status",
          width: 120
        },
        {
          title: "功能",
          slot: "action",
          width: 150
        }
      ],
      data: [],
      formData: {
        id: 0,
        activityid: 0,
        goodsid: 0
      }
    };
  },
  watch: {
    goodsdata: {
      handler: function(val, old) {
        this.data = this.goodsdata.activity;
      }
    }
  },
  methods: {
    storeData() {
      this.formData.goodsid = this.goodsdata.id;
      storeGoodsActivityData(this.formData)
        .then(res => {
          if (res.data.code == 200) {
            this.data.push(res.data.data);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_remove(row, index) {
      removeGoodsActivityData(row.id)
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
            this.data.splice(index, 1);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    }
  },
  props: ["activityList", "goodsdata"]
};
</script>